import React, { useContext } from 'react';
import { cn } from '@express-labs/raven-tools';
import IconV2, { IconV2IconNames } from '../../IconV2/IconV2';
import s from './AccordionHeader.scss';
import {
  AccordionItemContext,
  AccordionItemContextProps,
} from '../../AccordionItem/AccordionItemContext';

export interface AccordionHeaderProps {
  /** change the appearance of the open / close icon */
  indicatorType?: 'caret' | 'plusminus';
  /** The AccordionHeader was designed for text, but you can use any valid React Element */
  children: React.ReactNode;
  /** Classes that are appended to the div surrounding this component. */
  className?: string;
  /** Most Icons will need some additional CSS to align them properly with the text.  This class is appended to the end of the list of classNames for the icon. */
  classNameIcon?: string;
  /** The name of an IconV2 icon.  See IconV2 in raven-docs for list. */
  icon?: IconV2IconNames;
  isDecorated?: boolean;
}

const AccordionHeader = ({
  indicatorType = 'caret',
  children,
  className,
  classNameIcon,
  icon,
  isDecorated = true,
}: AccordionHeaderProps) => {
  const { expanded, toggleExpansion, panelId } =
    useContext<AccordionItemContextProps>(AccordionItemContext);

  return (
    <div className={cn(s.accordionHeader, className)}>
      <button
        className={cn(
          s.accordionHeaderButton,
          expanded && isDecorated && s.buttonText
        )}
        onClick={toggleExpansion}
        aria-expanded={expanded}
        aria-controls={panelId}
        role="tab"
      >
        <div className={s.miniGrid}>
          {icon && (
            <div className={cn(s.icon, classNameIcon)}>
              <IconV2 icon={icon} size="small" />
            </div>
          )}
          <div className={s.label}>
            <span className={s.labelAdjust}>{children}</span>
          </div>
          <div className={s.indicator}>
            {indicatorType === 'caret' && (
              <span
                className={cn(
                  s.chevronWrapper,
                  icon ? s.chevronWrapperDown : '',
                  expanded && s.open
                )}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12px"
                  height="9px"
                  viewBox="0 0 9 6"
                  className={s.caretIcon}
                >
                  <path className={s.caret} d="M.7 1.2L4.5 5l3.8-3.8" />
                </svg>
              </span>
            )}
            {indicatorType === 'plusminus' && (
              <span className={cn(s.plusMinusWrapper)}>
                {expanded && (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M7 11.353h10.206v1.5H7v-1.5Z" />
                  </svg>
                )}
                {!expanded && (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12.853 7v4.353h4.353v1.5h-4.353v4.353h-1.5v-4.353H7v-1.5h4.353V7z" />
                  </svg>
                )}
              </span>
            )}
          </div>
        </div>
      </button>
    </div>
  );
};

AccordionHeader.displayName = 'AccordionHeader';

export default AccordionHeader;
